export default "__VITE_ASSET__DHnGbxTx__"